module.exports = __webpack_public_path__ + "static/media/anim_logo_boat_texto_novo_loop.55bfc787.gif";